module.exports = __webpack_public_path__ + "static/c++-143f3b8cf3b0386663ef156f308e5d4c.png";